import env from '@framework/env/env';

export interface IRecaptchaConfig {
  visible: {
    siteKey?: string,
  },
  invisible: {
    siteKey?: string,
  },
}

const recaptchaConfig: IRecaptchaConfig = {
  visible: {
    siteKey: env('RECAPTCHA_VISIBLE__SITE_KEY'),
  },
  invisible: {
    siteKey: env('RECAPTCHA_INVISIBLE__SITE_KEY'),
  },
};

export default recaptchaConfig;
